import * as React from 'react';
import {Link} from 'react-router-dom';

import {BackButton} from 'shells/button/back-button/back-button';

import styles from './filter-bar.module.css';

type Props = {
    backButtonText: string;
    children: React.ReactNode;
};

export class FilterBar extends React.PureComponent<Props> {
    static defaultProps = {
        backButtonText: 'Back',
    };

    render() {
        return (
            <div className={styles.container}>
                <div className={styles['back-button-container']}>
                    <BackButton
                        // @ts-expect-error
                        as={Link}
                        to='/email/scheduled'
                        backText={this.props.backButtonText}
                    />
                </div>
                {this.props.children}
            </div>
        );
    }
}
